import React from 'react';
import Navbar from './Navbar';
import PartsList from './PartsList';
import Footer from './Footer';

const PartsListPage = () => {
  return (
    <div className="parts-list-page">
      <Navbar />
      <PartsList />
      <Footer />
    </div>
  );
};

export default PartsListPage;

